import * as angular from 'angular';
import template from './modal-terms-conditions.template.html';

export default {
  template,
  controller: 'ModalTermsConditionsController',
  controllerAs: '$ctrl',
  appendElement: angular.element(document.querySelector('app')),
};



// WEBPACK FOOTER //
// ./src/app/shared/modal/modal-terms-conditions/modal-terms-conditions.component.js